import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolders2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folders-2, collection, stuff"><path d="M2.75 6C3.16421 6 3.5 6.33579 3.5 6.75V18.5H18.25C18.6642 18.5 19 18.8358 19 19.25C19 19.6642 18.6642 20 18.25 20H2.75C2.33579 20 2 19.6642 2 19.25V6.75C2 6.33579 2.33579 6 2.75 6ZM10.25 3C10.4489 3 10.6396 3.07907 10.7803 3.21973L12.5605 5H21.25L21.3271 5.00391C21.7051 5.04253 22 5.36183 22 5.75V16.25C22 16.6642 21.6642 17 21.25 17H5.75C5.33579 17 5 16.6642 5 16.25V3.75C5 3.33579 5.33579 3 5.75 3H10.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolders2;
